import React, { FC } from 'react'

interface ReliabilitySaasProps {
    saasSoftwareData: any
}

const ReliabilitySaas: FC<ReliabilitySaasProps> = ({ saasSoftwareData }) => {
    return (
        <div>
            <div className='grid grid-cols-3 gap-12 p-20 pt-16 px-36'>
                {saasSoftwareData.ReliabilitySaaSSoftwareData.map((reliable: any) => {
                    return (
                        <div className=' bg-darkGreyPrimary rounded-3xl flex flex-col items-center justify-between ' >
                            <div className={`bg-${reliable.color} rounded-3xl pb-1`}>
                                <div className='bg-blackDarkThemeSecondary flex flex-col p-4 relative rounded-2xl'>
                                    <div className={`w-14 h-14 rounded-xl bg-darkGreyPrimary text-white flex items-center justify-center font-bold text-2xl mb-2`}>{reliable.key}.</div>
                                    <div className={`text-xl text-start font-semibold mb-1 text-white`}>{reliable.title}</div>
                                    <div className='text-lightGrey text-sm'>{reliable.subtitle}</div>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default ReliabilitySaas
